/* eslint-disable no-dupe-keys */
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  button: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    position: 'absolute',
    bottom: theme.spacing(2),
  },
  buttonText: {
    fontWeight: 700,
    color: theme.palette.blue.main,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  modalVideoImg: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    cursor: 'pointer',
  },
  modalContainer: {
    backgroundColor: 'rgba(0, 0, 0, .25)',
    height: 'auto',
    width: '100%',
    '&>div': {
      '&>div': {
        borderRadius: '8px',
        paddingBottom: '8px',
        width: '100%',
        maxHeight: '1200px',
        maxWidth: 1080,
        [theme.breakpoints.only('xs')]: {
          width: '100vw',
          height: 'auto',
        },
      },
    },
  },
  modal: {
    width: '100%',
    height: 'auto',
    overflow: 'hidden',
    border: '8px solid white',
    borderRadius: 8,
    overflow: 'hidden',
    '& video': {
      width: '100%',
    },
    borderBottom: 'none',
  },
}))

export default useStyles
